import { parse } from 'date-fns';
import { useMemo } from 'react';
import { HistoricalBalanceRecordDataPointsInner } from '../../resources/account.resource';
import { SERVER_DATE_FORMAT } from '../../utils/dateUtils';
import {
  DailyResolutionChartXAxisConfig,
  useDailyResolutionChartXAxisCommon,
  UseDailyResolutionChartXAxisParams,
} from './useDailyResolutionChartXAxisCommon';

const getDate = (dataPoint: HistoricalBalanceRecordDataPointsInner) =>
  parse(dataPoint.balanceDate, SERVER_DATE_FORMAT, new Date());

export type UseHistoricalBalanceChartXAxisParams = Omit<
  UseDailyResolutionChartXAxisParams<HistoricalBalanceRecordDataPointsInner>,
  'getDate'
>;

export const useHistoricalBalanceChartXAxisCommon = ({
  dataPoints,
  months,
}: UseHistoricalBalanceChartXAxisParams): DailyResolutionChartXAxisConfig => {
  const p: UseDailyResolutionChartXAxisParams<HistoricalBalanceRecordDataPointsInner> = useMemo(
    () => ({
      dataPoints,
      months,
      getDate,
    }),
    [dataPoints, months],
  );

  return useDailyResolutionChartXAxisCommon(p);
};
